export default "__VITE_ASSET__DRdp$xeC__"